import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const WhySection = () => {
  const { t } = useLanguage();
  
  const benefits = [
    {
      title: t("why.oneTeam"),
      description: t("why.oneTeamDesc"),
    },
    {
      title: t("why.endToEnd"),
      description: t("why.endToEndDesc"),
    },
    {
      title: t("why.faster"),
      description: t("why.fasterDesc"),
    },
    {
      title: t("why.vision"),
      description: t("why.visionDesc"),
      highlight: true,
    },
  ];

  return (
    <section id="why" className="py-16 md:py-24 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-pattern opacity-20" />
      
      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black mb-4 md:mb-6 text-glow-hover uppercase">
            {t("why.title")} <span className="text-holographic">{t("why.shape")}</span>?
          </h2>
          <p className="text-lg md:text-xl lg:text-2xl text-muted-foreground max-w-3xl mx-auto px-4">
            {t("why.subtitle")}
          </p>
        </div>

        {/* Benefits grid with cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="glass-card rounded-2xl p-6 md:p-8 glow-on-hover h-full hover-slide-up">
                {/* Icon */}
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="flex-shrink-0 mt-1">
                    <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-[hsl(var(--holographic-cyan))]" strokeWidth={2.5} />
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="text-lg md:text-xl lg:text-2xl font-bold mb-2 md:mb-3 hover-glow-text">
                      {benefit.title}
                      {benefit.highlight && (
                        <span className="text-holographic ml-2">{benefit.description}</span>
                      )}
                    </h3>
                    {!benefit.highlight && (
                      <p className="text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed">
                        {benefit.description}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA accent */}
        <div className="mt-16 text-center">
          <p className="text-lg md:text-xl text-muted-foreground px-8 py-4">
            {t("why.experience")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
